import { Textarea } from "@/components/ui/textarea";
import { getMessageStats } from "@/utils/smsUtils";

interface SMSTextareaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export function SMSTextarea({ value, onChange, placeholder, className }: SMSTextareaProps) {
  const stats = getMessageStats(value);

  return (
    <div className="w-full max-w-full">
      <Textarea
        placeholder={placeholder || "Enter SMS message body..."}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`min-h-24 w-full max-w-full ${className || ""}`}
      />
      <div className="flex justify-between items-center text-xs text-muted-foreground mt-1">
        <div>
          {value.length} / {stats.maxChars}
        </div>
        <div>
          {stats.numberOfSegments} segment{stats.numberOfSegments !== 1 ? "s" : ""}
        </div>
      </div>
    </div>
  );
}
